import { atom } from "jotai";

export const selectedCompositionOverrideAtom = atom<string | undefined>(undefined);
